import { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { addDays, format } from 'date-fns';
import { Button } from '@mui/material';
import { useAuth } from '../../../contexts/AuthContext';
import { usePost } from '../../../apis/ApiRequests';
import Header from '../../../components/uiParts/hygiene/Header';
import TitleBar from '../../../components/uiParts/TitleBar';
import { dateToString } from '../../../utils/Library';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper } from '@mui/material';
import {
	LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend,
} from "recharts";
import {
	Box,
	Card,
	Grid,
	Typography,
	Stack,
} from "@mui/material";
import { facilityData } from '../../../Store';

// ダーク配色
const DARK = {
	pageBg: "#0b1220",
	cardBg: "#111a2e",
	border: "rgba(255,255,255,0.12)",
	text: "rgba(255,255,255,0.92)",
	subText: "rgba(255,255,255,0.70)",
	grid: "rgba(255,255,255,0.12)",
	tooltipBg: "#0f172a",
};

const ScheduleMonitor = () => {

	const { authInfo, setAuthInfo } = useAuth();

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
	// initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode   = authInfo.facilityCode ? authInfo.facilityCode : facilityData.facilityCode;
    const facilityName   = authInfo.facilityName;
    const userId         = authInfo.userId ? authInfo.userId : 'Signage';
	const userName = authInfo.userName;
	const authority = authInfo.authority;
	const traderCode = authInfo.traderCode;
	const trader = authInfo.trader;
    const senmeiCode = authInfo.senmeiCode;
    const senmei = authInfo.senmei;

	const today = format(addDays(new Date(), 0), 'yyyy-MM-dd');
	const navigate = useNavigate();
	
	//-----------------------------------------------
	// initialize - useState
	//-----------------------------------------------
	const [ targetDate, setTargetDate ] = useState(today);
	const [ dataList, setDataList ] = useState([]);
	//const [ dataList, setDataList ] = useState([]);
	
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
	// API - searchDataByUnload / Signage
	//-----------------------------------------------
	const { response : searchData_res, post:searchData_post } = usePost();
	const searchData = async () => {
		const numericDate = dateToString(today);
		const postData = {
			'className'    : 'mch.models.table.Signage',
			'methodName'   : 'searchDataByAqualium',
			'facilityCode' : facilityCode,
			'userId'       : userId,
			'entryDate'    : numericDate,
		}
		await searchData_post(postData);
	};
	//-----------------------------------------------
	// API - searchData / table_Alert
	//-----------------------------------------------
	
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
	// useEffect - ロード時の設定
	//-----------------------------------------------
	useEffect(() => {

		searchData();
		
		// 5秒ごとにデータを更新するタイマーを設定
		const interval = setInterval(searchData, 5000);
	
		// コンポーネントのアンマウント時にタイマーをクリア
		return () => clearInterval(interval);
	},[]);
	//-----------------------------------------------
	// useEffect - searchDataByAqualium / Signage
	//-----------------------------------------------
	useEffect(() => {
		//setDataList([]);
		if (searchData_res) {
		//    setDataList(searchData_res.Data);
		}
	}, [searchData_res]);
	const { leftList, rightList } = useMemo(() => {
		const ROWS_PER_COL = 12;
		return {
			leftList:  dataList.slice(0, ROWS_PER_COL),
			rightList: dataList.slice(ROWS_PER_COL, ROWS_PER_COL * 2),
		};
	}, [dataList]);
	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
	// eventHandler - 日付の変更
	//-----------------------------------------------
	const handleChange_entryDate = (value) => {
	};
	//-----------------------------------------------
	// eventHandler - ホーム画面に戻る
	//-----------------------------------------------
	const handleClick_header = () => {
		userId == 'Signage' ? navigate('/') : navigate('/portHome');
	};
	//===============================================
	// Function
	//===============================================
    //===============================================
    // Css
    //===============================================
    const table_cell_header = {
        backgroundColor: '#fff', color: '#005243', borderRight:'3px solid #005243', borderBottom:'3px solid #005243', padding:'5px',  fontSize:'2em', fontWeight:'bold', height:'2em'
    }
	//===============================================
	// JSXのレンダー
	//===============================================
	return (
		<>
			<div className='signageContens' style={{ height: '100vh',overflow:'hidden' }}>
				<div  onClick={() => handleClick_header()}>
					<div>
						<span style={{fontSize:'1.5em', fontWeight:'bold', color:'#fff'}}>【{ today }の出漁情報】</span>
					</div>
					<div style={{ display: 'flex', }}>
					<div style={{ width: '48vw' }}>
						<TableContainer component={Paper} style={{border:'none', backgroundColor:'#efefef', marginTop:'1em'}}>
							<Table stickyHeader sx={{ padding:0 }} size="small">
								<TableHead>
									<TableRow>
									<TableCell sx={ table_cell_header } style={{ width: '25vh',borderLeft:'3px solid #fff' }} align="center">漁法</TableCell>
										<TableCell sx={ table_cell_header } style={{ width: '50vh' }} align="center">船名</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{leftList.map((row, index) => (
										<TableRow key = { row.id } >
											<TableCell align="left" style={{borderLeft:'3px solid #fff'}}>{ row.method }</TableCell>
											<TableCell align="left">{ row.displayGyoshu }</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					</div>
					<div style={{ width: '48vw', marginLeft:'20px' }}>
						<TableContainer component={Paper} style={{border:'none', backgroundColor:'#efefef', marginTop:'1em'}}>
							<Table stickyHeader sx={{ minWidth: '500px', padding:0 }} size="small">
								<TableHead>
									<TableRow>
									<TableCell sx={ table_cell_header } style={{ width: '25vh',borderLeft:'3px solid #fff' }} align="center">漁法</TableCell>
										<TableCell sx={ table_cell_header } style={{ width: '50vh' }} align="center">船名</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{rightList.map((row, index) => (
										<TableRow key = { row.id } >
											<TableCell align="left" style={{borderLeft:'3px solid #fff'}}>{ row.method }</TableCell>
											<TableCell align="left">{ row.displayGyoshu }</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ScheduleMonitor;